import { render, staticRenderFns } from "./NavCommonTopicCount.vue?vue&type=template&id=1607f985&"
import script from "./NavCommonTopicCount.vue?vue&type=script&lang=ts&"
export * from "./NavCommonTopicCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports